// @react-functional
import { useState, useEffect } from 'react';

import {
  getLegislationQpcDecisions,
  getLegislationReferenceDecisions,
} from '../../../legislation.api';

import { LegislationDecision } from '../../../legislation.types';

type State = {
  qpcDecisions: Array<LegislationDecision>;
  referenceDecisions: Array<LegislationDecision>;
};

export const useLinkedDecisionsFetcher = (articleId: string) => {
  const [decisions, setDecisions] = useState<State>({
    qpcDecisions: [],
    referenceDecisions: [],
  });

  useEffect(() => {
    const fetchData = async () => {
      const [
        qpcDecisionsFetched,
        referenceDecisionsFetched,
      ] = await Promise.all([
        getLegislationQpcDecisions(articleId),
        getLegislationReferenceDecisions(articleId),
      ]);
      setDecisions({
        qpcDecisions: qpcDecisionsFetched,
        referenceDecisions: referenceDecisionsFetched,
      });
    };

    fetchData();
  }, [articleId]);

  return decisions;
};
